var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-popover",
    {
      staticClass: "user-popover",
      attrs: { anchor: "bottom right", self: "top right" }
    },
    [
      _c(
        "q-list",
        { attrs: { "item-separator": "", link: "" } },
        [
          _c(
            "q-item",
            {
              directives: [
                { name: "close-overlay", rawName: "v-close-overlay" }
              ],
              attrs: { exact: "", to: { name: "settings" } }
            },
            [
              _c(
                "q-item-side",
                [_c("q-icon", { attrs: { name: "person" } })],
                1
              ),
              _c("q-item-main", [
                _c("span", [_vm._v(_vm._s(_vm.$t("profile")))])
              ])
            ],
            1
          ),
          _c(
            "q-item",
            {
              directives: [
                { name: "close-overlay", rawName: "v-close-overlay" }
              ],
              attrs: { exact: "", disabled: !_vm.activeTeam },
              nativeOn: {
                click: function($event) {
                  return _vm.handleTeamSettings($event)
                }
              }
            },
            [
              _c(
                "q-item-side",
                [_c("q-icon", { attrs: { name: "settings" } })],
                1
              ),
              _c("q-item-main", [
                _c("span", [_vm._v(_vm._s(_vm.$t("team_setting")))])
              ])
            ],
            1
          ),
          _c("q-item-separator"),
          _c(
            "q-item",
            {
              directives: [
                { name: "close-overlay", rawName: "v-close-overlay" }
              ],
              nativeOn: {
                click: function($event) {
                  return _vm.handleChangeTeam($event)
                }
              }
            },
            [
              _c(
                "q-item-side",
                [_c("q-icon", { attrs: { name: "swap_horiz" } })],
                1
              ),
              _c("q-item-main", [
                _c("span", [_vm._v(_vm._s(_vm.$t("change_team")))])
              ])
            ],
            1
          ),
          _c("q-item-separator"),
          _c(
            "q-item",
            {
              directives: [
                { name: "close-overlay", rawName: "v-close-overlay" }
              ],
              attrs: { id: "logout" },
              nativeOn: {
                click: function($event) {
                  return _vm.handleLogout($event)
                }
              }
            },
            [
              _c(
                "q-item-side",
                [_c("q-icon", { attrs: { name: "power_settings_new" } })],
                1
              ),
              _c("q-item-main", [
                _c("span", [_vm._v(_vm._s(_vm.$t("logout")))])
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("team-switcher", {
        ref: "teamSwitcher",
        attrs: { teams: _vm.teams, "active-team": _vm.activeTeam },
        on: { createTeam: _vm.handleCreateTeam }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }